module.exports = __webpack_public_path__ + "static/canopyDemo-69b0823156e1eb19e0dc8dcd425c0c79.mp4";